<template>
  <nav class="navbar navbar-expand-lg menu">
    <div class="container-fluid">
      <!-- Logo -->
      <router-link to="/" class="navbar-brand">
        <img src="../../assets/mt_logo.png" alt="Logo" width="120" height="30" class="d-inline-block align-text-top">
      </router-link>

      <!-- Navbar toggle for mobile view -->
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#mynavbar"
              aria-controls="mynavbar" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="mynavbar">
        <ul class="navbar-nav me-auto mb-2 mb-lg-0">
          <template v-if="store.isAuthenticated">
            <!-- My Calendar -->
            <li class="nav-item">
              <router-link class="nav-link" to="/vacation-calendar">
                <i class="bi bi-calendar"></i> {{ $t('menu.myCalendar') }}
              </router-link>
            </li>

            <!-- My Team Dropdown -->
            <li v-if="hasPermission('users.view_teams')" class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" href="#" id="myTeamDropdown" role="button"
                 data-bs-toggle="dropdown" aria-expanded="false">
                <i class="bi bi-people-fill"></i> {{ $t('menu.myTeam') }}
              </a>
              <ul class="dropdown-menu custom-dropdown" aria-labelledby="myTeamDropdown">
                <li>
                  <router-link class="dropdown-item custom-item" to="/my-team"><i class="bi bi-people"></i>
                    {{ $t('menu.myTeam') }}
                  </router-link>
                </li>
                <li>
                  <router-link class="dropdown-item custom-item" to="/rules"><i class="bi bi-list-task"></i>
                    {{ $t('menu.myRules') }}
                  </router-link>
                </li>


              </ul>
            </li>
            <!-- FAQ -->
            <li class="nav-item">
              <router-link class="nav-link" to="/help">
                <i class="bi bi-calendar"></i> FAQ
              </router-link>
            </li>

            <!-- Administration Dropdown -->
            <li v-if="hasPermission('users.view_administration')" class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" href="#" id="adminDropdown" role="button"
                 data-bs-toggle="dropdown" aria-expanded="false">
                <i class="bi bi-gear"></i> {{ $t('menu.administration') }}
              </a>
              <ul class="dropdown-menu custom-dropdown" aria-labelledby="adminDropdown">
                <li>
                  <router-link class="dropdown-item custom-item" to="/users"><i class="bi bi-people"></i>
                    {{ $t('menu.userList') }}
                  </router-link>
                </li>
                <li>
                  <router-link class="dropdown-item custom-item" to="/departments"><i class="bi bi-list-task"></i>
                    {{ $t('menu.departments') }}
                  </router-link>
                </li>
                <li>
                  <router-link class="dropdown-item custom-item" to="/positions"><i class="bi bi-journal"></i>
                    {{ $t('menu.positions') }}
                  </router-link>
                </li>
                <li>
                  <router-link class="dropdown-item custom-item" to="/job-levels"><i class="bi bi-award"></i>
                    {{ $t('menu.jobLevels') }}
                  </router-link>
                </li>
                <li>
                  <router-link class="dropdown-item custom-item" to="/locations"><i class="bi bi-geo-alt"></i>
                    {{ $t('menu.locations') }}
                  </router-link>
                </li>
                <li>
                  <router-link class="dropdown-item custom-item" to="/groups"><i class="bi bi-diagram-3"></i>
                    {{ $t('groupsAndPermissions') }}
                  </router-link>
                </li>
                <li>
                  <router-link class="dropdown-item custom-item" to="/year-settings"><i class="bi bi-calendar"></i>
                    {{ $t('menu.years') }}
                  </router-link>
                </li>
                <li>
                  <router-link class="dropdown-item custom-item" to="/holidays"><i class="bi bi-file-earmark-text"></i>
                    {{ $t('menu.holidays') }}
                  </router-link>
                </li>
                <li>
                  <router-link class="dropdown-item custom-item" to="/absence-types"><i
                      class="bi bi-card-checklist"></i> {{ $t('menu.absenceTypes') }}
                  </router-link>
                </li>
                <li>
                  <router-link class="dropdown-item custom-item" to="#"><i
                      class="bi bi-door-open"></i> {{ $t('menu.сompetences') }}
                  </router-link>
                </li>
              </ul>
            </li>

            <!-- Evaluation -->
<!--            <li v-if="hasPermission('users.view_evaluation')" class="nav-item dropdown">-->
<!--              <a class="nav-link dropdown-toggle" href="#" id="adminDropdown" role="button" data-bs-toggle="dropdown"-->
<!--                 aria-expanded="false">-->
<!--                <i class="bi bi-stars"></i> {{ $t('menu.evaluation') }}-->
<!--              </a>-->
<!--              <ul class="dropdown-menu custom-dropdown" aria-labelledby="adminDropdown">-->
<!--                <li>-->
<!--                  <router-link class="dropdown-item custom-item" to="#"><i class="bi bi-trophy"></i>-->
<!--                    {{ $t('menu.score') }}-->
<!--                  </router-link>-->
<!--                </li>-->
<!--                <li>-->
<!--                  <router-link class="dropdown-item custom-item" to="#"><i class="bi bi-clipboard2-check"></i>-->
<!--                    {{ $t('menu.results') }}-->
<!--                  </router-link>-->
<!--                </li>-->
                <!--                <li>-->
                <!--                  <router-link class="dropdown-item custom-item" to="/positions"><i class="bi bi-journal"></i>-->
                <!--                    {{ $t('menu.competences') }}-->
                <!--                  </router-link>-->
                <!--                </li>-->
<!--              </ul>-->
<!--            </li>-->

            <!-- Reports -->
<!--            <li v-if="hasPermission('users.view_reports')" class="nav-item">-->
<!--              <router-link to="#" class="nav-link"><i class="bi bi-graph-up"></i> {{ $t('menu.reports') }}</router-link>-->
<!--            </li>-->
          </template>
        </ul>

        <!-- Right-aligned buttons (My Profile / Log Out) -->
        <div class="d-flex ms-auto">
          <ul class="navbar-nav">
            <template v-if="store.isAuthenticated">
              <li class="nav-item">
                <router-link :to="{ name: 'UserDetail', params: { id: store.user.id } }"
                             class="nav-link button is-info">
                  {{ store.user.username }}
                </router-link>
              </li>

              <!-- Language Switch Dropdown -->
              <li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle" href="#" id="languageDropdown" role="button"
                   data-bs-toggle="dropdown" aria-expanded="false">
                  {{ currentLanguageLabel }}
                </a>
                <ul class="dropdown-menu custom-dropdown" aria-labelledby="languageDropdown">

                  <li><a class="dropdown-item" href="#" @click.prevent="switchLanguage('en')">🇬🇧 EN</a></li>
                  <li><a class="dropdown-item" href="#" @click.prevent="switchLanguage('uk')">🇺🇦 UA</a></li>
                </ul>
              </li>

              <!-- Dark Mode Toggle -->
              <!-- <li class="nav-item">
                <a @click="toggleDarkMode" class="nav-link button is-light theme-toggle" data-bs-toggle="tooltip" data-bs-placement="bottom"
                   :title="store.isDarkMode ? $t('menu.lightMode') || 'Light Mode' : $t('menu.darkMode') || 'Dark Mode'">
                  <i :class="store.isDarkMode ? 'bi bi-sun-fill' : 'bi bi-moon-fill'"></i>
                </a>
              </li> -->

              <!-- Log Out -->
              <li class="nav-item">
                <a @click="logout" class="nav-link button is-light" data-bs-toggle="tooltip" data-bs-placement="bottom"
                   :title="$t('menu.logOut')">
                  <img src="../../assets/logout.svg" alt="Log out" width="30" height="30"/>
                </a>
              </li>
            </template>

            <template v-else>
              <!-- Log In Button -->
              <li class="nav-item">
                <router-link to="/login" class="nav-link button is-success"><strong>{{ $t('menu.logIn') }}</strong>
                </router-link>
              </li>
            </template>
          </ul>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import { useMainStore } from '@/store';
import axios from 'axios';

export default {
  name: 'Navbar',
  data() {
    return {
      languages: {
        en: 'EN',
        uk: 'UA'
      }
    };
  },
  computed: {
    store: () => useMainStore(),
    currentLanguageLabel() {
      return this.languages[this.$i18n.locale] || 'Language';
    },
    userID() {
      return this.store.user.id || null;
    },
    hasPermission() {
      return (permission) => {
        const userPermissions = this.store.user.permissions || [];
        return userPermissions.includes(permission);
      };
    }
  },
  mounted() {
    const savedLanguage = localStorage.getItem('appLanguage');
    if (savedLanguage && this.languages[savedLanguage]) {
      this.$i18n.locale = savedLanguage;
    }
  },
  methods: {
    switchLanguage(lang) {
      this.$i18n.locale = lang;
      this.store.setAppLanguage(lang);
    },
    toggleDarkMode() {
      this.store.toggleDarkMode();
    },
    async logout() {
      try {
        await axios.post("/api/v1/admin/logout/");
      } catch (error) {
        console.log("Logout API failed:", error?.response?.status, error?.response?.data);
      } finally {
        this.store.logout();
        this.$router.push({ name: "LogIn" });
      }
    },
  }
};

</script>

<style scoped>
</style>
